

import { Component, Vue } from "vue-property-decorator"
import CasesOverview from "@/views/CaseDetails.vue"

@Component({
	components: {
		"case-details": CasesOverview
	}
})
export default class RestrictedCaseDetails extends Vue {
	public beforeDestroy (): void {
		window.close()
	}
}

